import React, { Component } from 'react';
import ReadAxios from "../axiosComponent/read";
import isEmpty from "lodash/isEmpty";

export default class BLrender extends Component {
  constructor(props) {
    super(props);

    this.state = {
      routeDetail: "",
    };
  }

  async componentDidMount() {

    let order_id = ""
    if (this.props.data)
      order_id = this.props.data.vendor_order_id ? this.props.data.vendor_order_id : this.props.data.order_id
    else
      order_id = this.props.id

    let dataArray =
      (await ReadAxios({
        completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/${order_id}/bl/list`
      })) || [];
    dataArray = isEmpty(dataArray) ? "" : dataArray.data.data;
    this.setState({ routeDetail: dataArray || "" });
    console.log(dataArray);
  }
  render() {
    const { t } = this.props;
    const { routeDetail } = this.state;
    return (
      <div>
        {/* <span>NA</span> */}
        <span>{routeDetail.length != "" ? routeDetail : "NA"}</span>
      </div>
    )
  }
}
